// SubscriptionWarning.jsx - Global subscription warning component
import React from 'react';
import { AlertTriangle, CreditCard, X, Clock } from 'lucide-react';
import styles from './SubscriptionWarning.module.css';

const SubscriptionWarning = ({ 
  subscriptionStatus, 
  showWarning, 
  warningMessage, 
  onGoToPayment, 
  onDismiss 
}) => {
  if (!showWarning || !subscriptionStatus) return null;

  const { daysRemaining, isExpired } = subscriptionStatus;

  // Determine warning level and styling
  const getWarningLevel = () => {
    if (isExpired) return 'critical';
    if (daysRemaining <= 1) return 'critical';
    if (daysRemaining <= 3) return 'warning';
    return 'info';
  };

  const warningLevel = getWarningLevel();

  const getIcon = () => {
    switch (warningLevel) {
      case 'critical':
        return <AlertTriangle size={20} />;
      case 'warning':
        return <Clock size={20} />;
      default:
        return <Clock size={20} />;
    }
  };

  return (
    <div className={`${styles.warningContainer} ${styles[warningLevel]}`} dir="rtl">
      <div className={styles.warningContent}>
        <div className={styles.warningIcon}>
          {getIcon()}
        </div>
        
        <div className={styles.warningText}>
          <div className={styles.warningMessage}>
            {warningMessage}
          </div>
          
          {!isExpired && (
            <div className={styles.warningSubtext}>
              {daysRemaining <= 3 ? 'פעולה נדרשת בדחיפות' : 'מומלץ לטפל בהקדם'}
            </div>
          )}
        </div>

        <div className={styles.warningActions}>
          <button 
            onClick={onGoToPayment}
            className={`${styles.paymentButton} ${styles[warningLevel]}`}
          >
            <CreditCard size={16} />
            {isExpired ? 'שלם עכשיו' : 'בחר תוכנית'}
          </button>
          
          {!isExpired && (
            <button 
              onClick={onDismiss}
              className={styles.dismissButton}
              title="סגור התראה"
            >
              <X size={16} />
            </button>
          )}
        </div>
      </div>
      
      {/* Progress bar for non-expired subscriptions */}
      {!isExpired && daysRemaining <= 7 && (
        <div className={styles.progressContainer}>
          <div 
            className={styles.progressBar}
            style={{ 
              width: `${Math.max(10, (daysRemaining / 7) * 100)}%`,
              backgroundColor: warningLevel === 'critical' ? '#dc2626' : 
                             warningLevel === 'warning' ? '#f59e0b' : '#3b82f6'
            }}
          />
        </div>
      )}
      
      {/* Pulsing animation for critical warnings */}
      {warningLevel === 'critical' && (
        <div className={styles.pulseAnimation}></div>
      )}
    </div>
  );
};

export default SubscriptionWarning;